export default __webpack_public_path__ + "static/media/Proprietary-device.91a6b43c.jpg";